module.exports = __webpack_public_path__ + "img/chanceflurries.db7211c2.png";